import { GenericHighlight } from "@/types/Highlights";

// we need to send the code of the premade highlight to the metadata service
// and filter out items that have action = DELETE
// sort by visualization_order to maintain the correct order
export function mapManageableHighlightToPremadeHighlight(items: GenericHighlight[]) {
  return items
    .filter((i) => i.action !== "DELETE")
    .sort((a, b) => (a.visualization_order || 0) - (b.visualization_order || 0))
    .map((i) => {
      if (i.code == null) {
        throw new Error("Premade highlight must have a code.");
      }
      return i.code;
    });
}
